import styled from 'styled-components';
import { Button } from 'ui/button/button.ui';

export const UploadInvoiceButtonContainer = styled(Button)`
  height: 32px;
  font-size: ${(props) => props.theme.font.body.size.small};
  min-width: 238px;
`;
